import axios from 'axios';
import {store} from '../store/Store';
import * as config from '../configs/Config';

const client = () => axios.create({
    baseURL: config.API_URL + '/admin',
    headers: {
        Authorization: 'Bearer ' + store.getState().auth.jwtToken,
        Accept: 'application/json',
    },
});

const qs = (params) => {
    const clean = Object.entries(params || {}).filter(([, v]) => v !== undefined && v !== null && v !== '');
    return clean.length ? '?' + new URLSearchParams(clean).toString() : '';
};

/** Errors come back as {status, message} so screens can show them. */
const call = (promise) => promise.then((r) => r.data).catch((err) => {
    throw {status: err.response?.status || 0, message: err.response?.data?.message || err.message};
});

export const getLab = (songId, params) => call(client().get(`/lab/songs/${songId}${qs(params)}`));
export const getRecommendSettings = () => call(client().get('/settings/recommend'));
export const saveRecommendSettings = (profile, values) => call(client().put('/settings/recommend', {profile, values}));
export const resetRecommendSettings = (profile) => call(client().delete('/settings/recommend' + qs({profile})));
export const getCatalogSongs = (params) => call(client().get('/catalog/songs' + qs(params)));
export const getCatalogArtists = (params) => call(client().get('/catalog/artists' + qs(params)));
export const getGenres = () => call(client().get('/genres'));
export const saveGenres = (map) => call(client().put('/genres', map));
export const resetGenres = () => call(client().delete('/genres'));
export const getUsers = (params) => call(client().get('/users' + qs(params)));
export const updateUser = (id, values) => call(client().patch(`/users/${id}`, values));
export const deleteUser = (id) => call(client().delete(`/users/${id}`));
export const sendUserReset = (id) => call(client().post(`/users/${id}/password-reset`));

export const FAMILY_LABELS = {
    rock: 'Rock', hiphop: 'Hip-hop', pop: 'Pop', rnb: 'R&B', electronic: 'Electronic', latin: 'Latin',
    brazil: 'Brazilian', country: 'Country', christian: 'Christian', reggae: 'Reggae', afro: 'Afro',
    jazzblues: 'Jazz & blues', folk: 'Folk', classical: 'Classical',
};
